import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35ea6124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recommended-products" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "formCap" }, "おすすめプラン", -1))
const _hoisted_3 = { class: "result" }
const _hoisted_4 = { class: "result-tabs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "業界初！", -1))
const _hoisted_6 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_7 = { class: "single" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tab-content-title" }, "1カ国専用プラン", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "noticeTxt" }, " ご選択の通信容量を超過すると、日本時間の0時まで通信速度が低速となります（無制限プランを除く）。 ", -1))
const _hoisted_10 = { class: "multiple" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tab-content-title" }, "周遊プラン", -1))
const _hoisted_12 = {
  key: 1,
  class: "tab-content empty"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "該当プランがありません", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_16 = { class: "single" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tab-content-title" }, "1カ国専用プラン", -1))
const _hoisted_18 = { class: "multiple" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tab-content-title" }, "周遊プラン", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "業界初！", -1))
const _hoisted_21 = {
  key: 3,
  class: "tab-content empty"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "該当プランがありません", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 4,
  class: "error-message"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "formCap" }, "WIFI台数", -1))
const _hoisted_26 = { class: "unit-select" }
const _hoisted_27 = { class: "select-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wi_fi_product_list = _resolveComponent("wi-fi-product-list")!
  const _component_Field = _resolveComponent("Field")!
  const _component_pull_down_select = _resolveComponent("pull-down-select")!
  const _component_input_field = _resolveComponent("input-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: _normalizeClass(["tab", { selected: _ctx.formStatus.tabIndex === 1 }]),
            for: "daily"
          }, " デイリープラン ", 2),
          _createElementVNode("label", {
            class: _normalizeClass(["tab", { selected: _ctx.formStatus.tabIndex === 2 }]),
            for: "pack"
          }, [
            _hoisted_5,
            _createTextVNode("使い切りパックプラン ")
          ], 2)
        ]),
        _createVNode(_component_Field, {
          name: "wifi_product_select",
          rules: _ctx.validRules.wifiProduct,
          "model-value": _ctx.selectedWiFi
        }, {
          default: _withCtx(({ errors, errorMessage }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["result-body", { invalid: errorMessage }])
            }, [
              _createElementVNode("input", {
                type: "radio",
                name: "plans",
                id: "daily",
                value: "1",
                checked: "checked",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChangeProductTab && _ctx.onChangeProductTab(...args)))
              }, null, 32),
              (!_ctx.isAllDailyProductEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_wi_fi_product_list, {
                        class: "tab-content-body",
                        products: _ctx.dailySingleProducts,
                        modelValue: _ctx.selectedWiFi,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedWiFi) = $event)),
                        "is-invalid": !!errorMessage
                      }, null, 8, ["products", "modelValue", "is-invalid"])
                    ], 512), [
                      [_vShow, _ctx.dailySingleProducts.length !== 0]
                    ]),
                    _hoisted_9,
                    _withDirectives(_createElementVNode("a", {
                      class: "open-multiple-plans",
                      onClick: _cache[2] || (_cache[2] = 
                () => {
                  _ctx.formStatus.isDailyMultiplePlanOpened =
                    !_ctx.formStatus.isDailyMultiplePlanOpened;
                }
              )
                    }, " 周遊プランを見る ", 512), [
                      [_vShow, 
                !_ctx.formStatus.isDailyMultiplePlanOpened &&
                _ctx.dailyMultiProducts.length !== 0
              ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_wi_fi_product_list, {
                        class: "tab-content-body",
                        products: _ctx.dailyMultiProducts,
                        modelValue: _ctx.selectedWiFi,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedWiFi) = $event)),
                        "is-invalid": !!errorMessage
                      }, null, 8, ["products", "modelValue", "is-invalid"])
                    ], 512), [
                      [_vShow, _ctx.formStatus.isDailyMultiplePlanOpened]
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)),
              _createElementVNode("input", {
                type: "radio",
                name: "plans",
                id: "pack",
                value: "2",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChangeProductTab && _ctx.onChangeProductTab(...args)))
              }, null, 32),
              (!_ctx.isAllPackProductEmpty)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_wi_fi_product_list, {
                        class: "tab-content-body",
                        products: _ctx.packSingleProducts,
                        modelValue: _ctx.selectedWiFi,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedWiFi) = $event)),
                        "is-invalid": !!errorMessage
                      }, null, 8, ["products", "modelValue", "is-invalid"])
                    ], 512), [
                      [_vShow, _ctx.packSingleProducts.length !== 0]
                    ]),
                    _withDirectives(_createElementVNode("a", {
                      class: "open-multiple-plans",
                      onClick: _cache[6] || (_cache[6] = 
                () => {
                  _ctx.formStatus.isPackMultiplePlanOpened =
                    !_ctx.formStatus.isPackMultiplePlanOpened;
                }
              )
                    }, " 周遊プランを見る ", 512), [
                      [_vShow, 
                !_ctx.formStatus.isPackMultiplePlanOpened &&
                _ctx.packMultiProducts.length !== 0
              ]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_wi_fi_product_list, {
                        class: "tab-content-body",
                        products: _ctx.packMultiProducts,
                        modelValue: _ctx.selectedWiFi,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedWiFi) = $event)),
                        "is-invalid": !!errorMessage
                      }, null, 8, ["products", "modelValue", "is-invalid"])
                    ], 512), [
                      [_vShow, _ctx.formStatus.isPackMultiplePlanOpened]
                    ]),
                    _hoisted_20
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)),
              errorMessage
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", null, _toDisplayString(errors[0]), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["rules", "model-value"])
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_input_field, {
          label: "レンタル台数",
          "input-name": 'unit-select',
          class: "unit"
        }, {
          default: _withCtx(({ inputName }) => [
            _createVNode(_component_pull_down_select, {
              options: _ctx.prepareUnitOptions(),
              name: inputName,
              "model-value": _ctx.wifiUnit,
              onChange: _ctx.onChange
            }, null, 8, ["options", "name", "model-value", "onChange"])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}